import { makeStyles } from '@material-ui/core';
import * as React from 'react';
import { useSnapCarousel } from 'react-snap-carousel';
import classNames from 'classnames';


interface MobileGallerySliderProps {
  className?: string;
  itemClassName?: string;
  controlMargin?: number;
}

export const MobileGallerySlider: React.FC<MobileGallerySliderProps> = ({
  children,
  className,
  itemClassName,
  controlMargin,
}) => {
  const classes = useStyles();
  const {scrollRef, goTo, activePageIndex } = useSnapCarousel({axis: 'x'});

  return (
    <>
      <div className={classNames(classes.scrollContainer, className)} ref={scrollRef}> 
        {React.Children.map(children, (child) => (
          <div className={classNames(classes.item, itemClassName)}>{child}</div>
        ))}
      </div>
      <div className={classes.controlRoot} style={{marginTop: controlMargin ?? 16, marginBottom: 16 - (controlMargin ?? 16)}}>
        {Array.from({length: React.Children.count(children)}, (_, k) => (
          <div 
            key={k+"mobileGallerySlider"} 
            onClick={() => goTo(k)} 
            className={classNames({
              [classes.circle]: true,
              [classes.circleActive]: activePageIndex === k,
            })} 
          />
        ))}
      </div>
    </>

  )
}

const useStyles = makeStyles((theme) => ({
  scrollContainer: {
    position: "relative",
    display: "flex",
    flexFlow: 'row nowrap',
    overflow: "auto",
    width: '100%',
    scrollSnapType: "x mandatory",
    scrollbarWidth: "none",
    scrollPadding: '0 5%',
    boxSizing: "border-box",
    overscrollBehavior: "contain",
    "&::-webkit-scrollbar": {
      display: "none",
    }
  },
  item: {
    scrollSnapAlign: 'center',
  },
  controlRoot: {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    gap: 9,
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    }
  },
  circle: {
    width: 16,
    height: 16,
    borderRadius: 8,
    backgroundColor: '#E3E4E8',
  },
  circleActive: {
    backgroundColor: theme.palette.primary.light,
  }
}));